import InteractionBase from '../InteractionBase';
import { StateStarBreathingCopy } from './states/StateStarBreathingCopy';
import { StateStarBreathingDraw } from './states/StateStarBreathingDraw';
import { StateStarBreathingIntro } from './states/StateStarBreathingIntro';
const assetpack = require('../../../../assets/assetpack_starbreathing.json');

export default class InteractionStarBreathing extends InteractionBase {
  constructor() {
    super('star_breathing');
  }
  init({ tracking = {} }) {
    this.tracking = tracking;
  }
  preload() {
    this.game.loader.loadAssetPack(
      assetpack,
      Object.keys(assetpack),
      this.handleLoadComplete.bind(this)
    );
  }

  handleLoadComplete() {
    // scene display objects
    this.background = this.add.image(910, 390, 'background_blue');
    this.backgroundSpine = this.add.spine(910, 390, 'breathing_background', 'animation', true);
    this.backgroundSpine.scale = 1.1;
    this.backgroundSpine.timeScale = 0.5;
    // states
    this.stateIntro = new StateStarBreathingIntro(this);
    this.stateDraw = new StateStarBreathingDraw(this);
    this.stateCopy = new StateStarBreathingCopy(this);
    // callbacks
    this.stateIntro.on('state_complete', this.stateMachine.nextState, this.stateMachine);
    this.stateDraw.on('state_complete', this.stateMachine.nextState, this.stateMachine);
    this.stateCopy.on('state_complete', this.endInteraction, this);
    // start
    this.stateMachine.setStateOrder([this.stateIntro, this.stateDraw, this.stateCopy]);
    this.stateMachine.nextState();
  }
}
